import React, { useRef, useState, useEffect, useContext } from "react";
import * as S from "./styles";
import iconUser from "../../assets/navbar/Pessoa_fisica_on_light_blue.svg";
import people from "../../services/people";
import person from "../../services/person";
import toDateISO from "../../utils/formatData";
import desmaskIfNumber from "../../utils/desmaskIfNumber";

import { Formik, Form, Field } from "formik";

import InputText from "../../components/InputText";
import Button from "../../components/Button";
import Navbar from "../../components/Navbar";
import InputSearch from "../../components/InputSearch";
import calcYear from "../../utils/calcYear";
import { useHistory, useParams } from "react-router-dom";

import { toast } from "react-toastify";
import firstSchema from "./validations/schemaValidation";
import { IoSearch } from "react-icons/io5";
import { BsSearch } from "react-icons/bs";

import SkeletonRadioInput from "../../components/SkeletonRadioInput";
import Skeleton from "../../components/skeleton";
import { Context } from "../../context/globalContext";

export default function RegistrationUser() {
  const history = useHistory();
  const formRef = useRef(null);
  const { id } = useParams();
  const [cityData, setCityData] = useState();
  const [initialState, setInitialState] = useState({});
  const [editingPerson, setEditingPerson] = useState(false);
  const globalContext = useContext(Context);

  const getMainEmail = (emails) => {
    let mainEmail;
    for (let index = 0; index < emails.length; index++) {
      let currentElement = emails[index];
      if (currentElement.emailPrincipal === true) {
        mainEmail = currentElement;
        break;
      } else {
        mainEmail = "";
      }
    }
    return mainEmail;
  };

  useEffect(() => {
    if (id) {
      getDataByUserId();
    } else {
      setInitialState({
        ...initialState,
        dataNascimento: "",
        pessoaContatoEmail: "",
        pessoaContatoTelefone: "",
        enderecos: "",
        nome: "",
        nomeFantasia: "",
        cidade: "",
        estado: "",
      });
      setCityData(null);
    }

    id !== undefined && setEditingPerson(true);
  }, [id]);

  const getDataByUserId = async () => {
    await person
      .listData(id)
      .then(async (ev) => {
        const data = ev?.data;
        if (data) {
          setInitialState(data);

          let dataNascimento = await new Date(
            data?.dataNascimento
          ).toLocaleDateString("pt-BR");

          const pessoaContatoTelefone = data?.pessoaContatoTelefone;
          const pessoaContatoEmail = data?.pessoaContatoEmail;

          const enderecos = data?.enderecos;
          const mainEmail = getMainEmail(pessoaContatoEmail);
          const lastPhone =
            pessoaContatoTelefone[pessoaContatoTelefone?.length - 1];
          const lastEnderecos = enderecos[enderecos?.length - 1];

          setInitialState({
            ...data,
            dataNascimento,
            pessoaContatoEmail: mainEmail,
            pessoaContatoTelefone: lastPhone,
            enderecos: lastEnderecos,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar dados!");
        }
      });
  };

  const sendData = async (dataForm) => {
    globalContext.setIsLoading(true);

    const dataSending = {
      nome: dataForm?.nome,
      cpfCnpj: desmaskIfNumber(dataForm?.cpfCnpj),
      dataNascimento: toDateISO(dataForm?.dataNascimento),
      tipoPessoa: "PESSOA_FISICA",
      nomeFantasia: dataForm?.nome,
      enderecos: [
        {
          cep: dataForm?.enderecos?.cep,
          bairro: dataForm?.enderecos?.bairro,
          uf: null,
          logradouro: dataForm?.enderecos?.logradouro,
          numero: dataForm?.enderecos?.numero,
          complemento: dataForm?.enderecos?.complemento,
          municipio: {
            ...cityData,
          },
        },
      ],
      pessoaContatoEmail: dataForm?.pessoaContatoEmail?.email
        ? [{ email: dataForm?.pessoaContatoEmail?.email }]
        : [],
      pessoaContatoTelefone: [
        {
          telefone: dataForm?.pessoaContatoTelefone?.telefone,
          tipoContato: "PESSOAL",
        },
      ],
    };

    const handleEditing = async () => {
      try {
        const response = await people.editingData(id, dataSending);
        if (response.status === 201 || response.status === 200) {
          toast.success("Dados atualizados com sucesso!");
        } else {
          toast.error(
            "Erro ao atualizar dados, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao atualizar dados, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
        getDataByUserId();
      }
    };

    const handleCreate = async () => {
      try {
        const response = await people.sendData(dataSending);
        if (response.status === 201 || response.status === 200) {
          toast.success("Dados cadastrados com sucesso!");
        } else {
          toast.error(
            "Erro ao cadastrar dados, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao cadastrar dados, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    };

    if (id) {
      handleEditing();
    } else {
      handleCreate();
    }
  };

  const handleSubmit = () => {
    if (formRef.current) {
      if (formRef.current.isValid) {
        sendData(formRef.current.values);
      }
    }
  };

  const handleSearch = (item) => {
    setCityData(item);
  };

  const findUserInSgs = async () => {
    const values = formRef.current.values;
    if (values.cpfCnpj && values.cpfCnpj.length > 0) {
      globalContext.setIsLoading(true);
      try {
        const integrationResponse = await person.integrationPerson(
          desmaskIfNumber(values.cpfCnpj)
        );
        if (integrationResponse && integrationResponse.status === 200) {
          history.push(
            `/cadastro-pessoa-fisica/${integrationResponse?.data?.id}`
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Preencha um cpf válido.");
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    } else {
      toast.error("Preencha um cpf válido.");
    }
  };

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={iconUser} />
            <div>
              <S.Title>Cadastro de pessoa física</S.Title>
              <S.Description>Informações básicas sobre a pessoa</S.Description>
            </div>
          </S.BoxUser>
        </S.Header>

        <S.Content>
          <Formik
            innerRef={formRef}
            initialValues={initialState}
            enableReinitialize={true}
            validationSchema={firstSchema}
          >
            {({ errors, touched, values }) => (
              <Form>
                <Field
                  name="cpfCnpj"
                  id="cpfCnpj"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        type="text"
                        width="50%"
                        label="CPF:"
                        maskChar=""
                        mask="999.999.999-99"
                        currency="false"
                        disabled={id}
                        iconComponent={
                          !id ? (
                            <IoSearch
                              onClick={() => findUserInSgs()}
                              cursor="pointer"
                              color="#00a2e0"
                              size="25px"
                            />
                          ) : (
                            <></>
                          )
                        }
                        error={errors.cpfCnpj && touched.cpfCnpj}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />
                <p>{errors.cpfCnpj}</p>
                <Field
                  name="nome"
                  id="nome"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        type="text"
                        width="90%"
                        label="Nome:"
                        currency="false"
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />
                <S.InputBox>
                  <Field
                    name="dataNascimento"
                    id="dataNascimento"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          type="text"
                          label="Data de Nascimento:"
                          maskChar=""
                          mask="99/99/9999"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                  <Field
                    name="idade"
                    id="idade"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          disabled
                          type="text"
                          label="Idade:"
                          value={
                            values?.dataNascimento?.length === 10
                              ? calcYear(values.dataNascimento)
                              : ""
                          }
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="pessoaContatoEmail.email"
                    id="email"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="E-mail:"
                          type="email"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="pessoaContatoTelefone.telefone"
                    id="telefone"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Telefone:"
                          mask="(99)99999-9999"
                          maskChar=""
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.SubTitle>Endereço</S.SubTitle>

                <S.InputBox>
                  <Field
                    name="enderecos.logradouro"
                    id="logradouro"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Logradouro:"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                  <Field
                    name="enderecos.numero"
                    id="numero"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Número:"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox columns="1fr 1fr 1fr" gap="1rem">
                  <Field
                    name="enderecos.complemento"
                    id="Complemento"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Complemento:"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="enderecos.bairro"
                    id="bairro"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Bairro:"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="enderecos.cep"
                    id="cep"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          style={{ marginLeft: "0" }}
                          {...field}
                          label="CEP:"
                          maskChar=""
                          mask="99999-999"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="enderecos.municipio.descricao"
                    id="cidade"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputSearch
                          {...field}
                          handleSearch={handleSearch}
                          initialValue={initialState?.enderecos?.municipio}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="enderecos.uf"
                    id="estado"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          label="Estado:"
                          {...field}
                          disabled
                          value={cityData?.estado?.nome}
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>
              </Form>
            )}
          </Formik>
          <S.ButtonContainer>
            <Button button="primary" onClick={history.goBack}>
              Voltar
            </Button>
            <Button button="primary" onClick={() => handleSubmit()}>
              Salvar cadastro
            </Button>
          </S.ButtonContainer>
        </S.Content>
      </S.Wrapper>
    </>
  );
}
